// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1fJtA","actionsCol":"EnrolledClinics_actionsCol__3mY2h"};